export const isEnabled = (flag: any) => flag === 'on';
